import { AgeGroup } from './age-group.model';
import { IncomeGroup } from './income-group.model';
import { RangeFilterType } from './range-filter-type.enum';
import { SpendingGroup } from './spending-group.model';

export class RangeFilter {
  constructor(
    public name?: string,
    public greaterThan?: number,
    public lessThan?: number,
    public type?: string,
    public id?: number
  ) {}

  public static fromAgeGroup(ageGroup: AgeGroup) {
    return new RangeFilter(
      ageGroup.name,
      ageGroup.greaterThan,
      ageGroup.lessThan,
      RangeFilterType.AGE,
      ageGroup.id
    );
  }

  public static fromSpendingIncomeGroup(
    spendingGroup: SpendingGroup | IncomeGroup
  ) {
    return new RangeFilter(
      spendingGroup.name,
      spendingGroup.greaterThan,
      spendingGroup.lessThan,
      RangeFilterType.SPENDING,
      spendingGroup.id
    );
  }
}
